import React from 'react';
import { Modal as AntdModal } from 'antd';
import { useFormContext, Controller } from 'react-hook-form';

import { Button, DatePicker, Tooltip } from 'components/ui';

const SendButton = ({
  disabled,
  totalRows,
  onSend,
  isLoading,
  disableSchedule,
}) => {
  const { control, handleSubmit, watch } = useFormContext();

  const scheduledTime = watch('scheduledTime');

  const onSubmit = isScheduling => values => {
    AntdModal.confirm({
      title: 'Confirmation',
      content: `You are about to send to ${totalRows} email ${
        totalRows < 2 ? 'address' : 'addresses'
      }. Are you sure you want to continue?`,
      okText: 'Yes',
      okType: 'primary',
      onOk: () => {
        onSend(values, isScheduling);
      },
      cancelText: 'No',
    });
  };

  return (
    <div className="send-mail-form__submit-section">
      <Button
        className="send-mail-form__submit-btn"
        disabled={disabled || scheduledTime || isLoading}
        onClick={handleSubmit(onSubmit(false))}
      >
        Send
      </Button>

      <span className="send-mail-form__send-hint">or</span>

      <div className="send-mail-form__schedule-send-wrapper">
        <Controller
          control={control}
          name="scheduledTime"
          render={({ field, fieldState }) => {
            return (
              <DatePicker
                disabled={disabled || disableSchedule || isLoading}
                helperText={fieldState.error?.message}
                showTime
                validationStatus={!fieldState.error}
                onChange={date => field.onChange(date && date.toISOString())}
                onOk={date => field.onChange(date.toISOString())}
              />
            );
          }}
        />

        <Button
          className="send-mail-form__schedule-submit-btn"
          disabled={disabled || disableSchedule || !scheduledTime || isLoading}
          onClick={handleSubmit(onSubmit(true))}
        >
          Schedule Send
        </Button>

        <Tooltip title="Time is set according to your system clock">
          <i className="material-icons">info</i>
        </Tooltip>
      </div>
    </div>
  );
};

export default SendButton;
